import i18n from "@/i18n/index";

export const REPORTS_PROPS = {
    showFullScreen: { type: Boolean, default: true },
    activitiesData: { type: Array, default: () => [] },
    selectedAchoredPlugin: { type: Object, default: () => {} },
    propFullScreen: { type: Boolean, default: false },
    propExpand: { type: String, default: "collapse" },
    readonly: { type: Boolean, default: false },
    hasExternalData: { type: Boolean, default: false },
    tasksInstExData: { type: Object, default: () => {} },
    selectedProcess: { type: Object, default: () => ({}) },
    resetFilters: { type: Boolean, default: false },
    customInterface: { type: Boolean, default: false },
    perspectiveId: { type: String, default: "" },
    pageType: { type: String, default: "" },
    activitiesDataPerspective: { type: Array, default: () => [] },
    isStatistics: { type: Boolean, default: false },
    reduseFromTableHeight: { type: Number, default: 0 }
};

export const TABLE_TASKS_CONFIG = [
    {
        name: "priority",
        label: i18n.t("liveView.tasksInstances.priority"),
        align: "center",
        field: "priority",
        visible: true,
        sortable: true,
        style: "width:1%"
    },
    {
        name: "taskName",
        align: "left",
        label: i18n.t("liveView.tasksInstances.taskName"),
        field: "subject",
        visible: true,
        sortable: true,
        style: "min-width:210px"
    },
    {
        name: "instanceName",
        align: "left",
        label: i18n.t("liveView.tasksInstances.instanceName"),
        field: "processInstanceName",
        sortable: true,
        style: "min-width:210px"
    },
    {
        name: "instanceID",
        align: "left",
        label: i18n.t("liveView.tasksInstances.instanceId"),
        field: "processInstanceId",
        sortable: true,
        style: "width:1%"
    },
    {
        name: "activity",
        align: "center",
        label: i18n.t("liveView.tasksInstances.activity"),
        field: "taskName",
        visible: true,
        sortable: true,
        style: "width:1%"
    },
    {
        name: "assignment",
        align: "center",
        label: i18n.t("liveView.tasksInstances.assignment"),
        field: "taskId",
        visible: true,
        style: "width:1%"
    },
    {
        name: "creationDate",
        align: "right",
        label: i18n.t("liveView.tasksInstances.creationDate"),
        field: "creationDate",
        visible: true,
        sortable: true,
        style: "width:1%"
    },
    {
        name: "deadline",
        align: "right",
        label: i18n.t("liveView.tasksInstances.deadline"),
        field: "timeToDeadline",
        visible: true,
        sortable: true,
        style: "width:1%"
    },
    {
        name: "expiration",
        align: "right",
        label: i18n.t("liveView.tasksInstances.expiration"),
        field: "timeRemaining",
        sortable: true,
        style: "width:1%"
    },
    {
        name: "status",
        align: "center",
        label: i18n.t("liveView.tasksInstances.status"),
        field: "status",
        visible: true,
        sortable: true,
        style: "width:1%"
    },
    {
        name: "action",
        align: "center",
        label: i18n.t("liveView.tasksInstances.action"),
        field: "action",
        visible: true,
        style: "width:1%"
    },
    {
        name: "more",
        align: "center",
        label: i18n.t("liveView.tasksInstances.more"),
        field: "more",
        visible: true,
        style: "width:1%"
    }
];

export const TABLE_INSTANCES_CONFIG = [
    {
        name: "instanceName",
        align: "left",
        label: i18n.t("liveView.tasksInstances.instanceName"),
        field: "instanceName",
        sortable: true,
        visible: true,
        style: "min-width:210px"
    },
    {
        name: "instanceID",
        align: "left",
        label: i18n.t("liveView.tasksInstances.instanceId"),
        field: "instanceId",
        sortable: true,
        visible: true,
        style: "width:1%"
    },
    {
        name: "creationSource",
        align: "left",
        label: i18n.t("liveView.tasksInstances.creationSource"),
        field: "creationSource",
        sortable: true,
        style: "width:1%"
    },
    {
        name: "creationDate",
        align: "right",
        label: i18n.t("liveView.tasksInstances.creationDate"),
        field: "startDate",
        sortable: true,
        visible: true
    },
    {
        name: "completionDate",
        align: "right",
        label: i18n.t("liveView.tasksInstances.completionDate"),
        field: "endDate",
        sortable: true,
        visible: true,
        style: "width:1%"
    },
    {
        name: "task",
        align: "center",
        label: i18n.t("liveView.tasksInstances.instancesActivity"),
        field: "instanceId",
        visible: true,
        style: "width:1%"
    },
    {
        name: "endActivityName",
        align: "left",
        label: i18n.t("liveView.tasksInstances.finalStage"),
        field: "endActivityName",
        visible: true,
        sortable: true,
        style: "width:1%"
    },
    {
        name: "status",
        align: "center",
        label: i18n.t("liveView.tasksInstances.status"),
        field: "systemStatus",
        sortable: true,
        visible: true,
        style: "width:1%"
    },
    {
        name: "action",
        align: "center",
        label: i18n.t("liveView.tasksInstances.action"),
        field: "action",
        visible: true,
        style: "width:1%"
    }
];

export const TABLE_FIXED_COLS = [
    {
        name: "action",
        align: "center",
        required: true,
        label: i18n.t("liveView.tasksInstances.action"),
        field: "action",
        visible: true,
        style: "width: 1%"
    },
    {
        name: "more",
        align: "center",
        label: i18n.t("liveView.tasksInstances.more"),
        field: "more",
        visible: true,
        style: "width: 1%"
    }
];

export const DEFAULT_SORT_COLUMNS = [
    "priority", "taskName", "instanceName", "instanceID", "activity", "creationDate",
    "deadline", "expiration", "status", "creationSource", "completionDate", "endActivityName"
];

export const MORE_OPTIONS = [
    { value: "unclaim", label: i18n.t("liveView.tasksInstances.unclaim") },
    { value: "reassign", label: i18n.t("liveView.tasksInstances.reassign") }
];

export const BULK_OPTIONS = [
    { value: "bulkUnclaim", label: i18n.t("liveView.tasksInstances.bulkUnclaim") },
    { value: "bulkReassign", label: i18n.t("liveView.tasksInstances.bulkReassign") },
    { value: "bulkReassignExternal", label: i18n.t("liveView.tasksInstances.bulkReassignExternal") }

];

export const TASKS_CELLS_PROPS = {
    priority: {
        style: "padding-right: 20px !important"
    },
    taskName: {
        class: "task-container"
    },
    instanceName: {
        class: "cell-container-color"
    },
    instanceID: {
        class: "cell-container-color instanceId-width"
    },
    activity: {
        style: "padding-right: 20px !important"
    },
    assignment: {
        class: "assignment-container"
    },
    creationDate: {
        class: "cell-container-color cell-medium-width"
    },
    deadline: {
        class: "cell-container-color cell-medium-width"
    },
    expiration: {
        class: "cell-container-color cell-medium-width"
    },
    action: {
        class: "action-container"
    },
    status: {
        style: "padding-right: 20px !important"
    },
    more: {
        class: "remove-background"
    }
};

export const INSTANCES_CELLS_PROPS = {
    instanceID: {
        class: "cell-container-color instanceId-width"
    },
    creationDate: {
        class: "cell-container-color cell-medium-width"
    },
    completionDate: {
        class: "cell-container-color"
    },
    status: {
        style: "padding-right: 20px !important"
    },
    action: {
        class: "action-container"
    }
};

export const TASK_STATUSES = {
    TOP_LEFT: "ON_TRACK",
    TOP_RIGHT: "ATTENTION",
    BOTTOM_LEFT: "AT_RISK",
    BOTTOM_RIGHT: "OVERDUE"
};

export const TASKS_LOADING_STYLE = {
    priority: "width: 56px",
    instanceID: "width: 148px",
    activity: "width: 56px",
    assignment: "width: 194px",
    creationDate: "width: 104px",
    deadline: "width: 104px",
    expiration: "width: 104px",
    status: "width: 48px",
    action: "width: 59px",
    more: "width: 40px"
};

export const INSTANCES_LOADING_STYLE = {
    instanceID: "width: 148px",
    creationDate: "width: 104px",
    completionDate: "width: 104px",
    activity: "width: 52px",
    status: "width: 83px",
    action: "width: 59px"
};

export const TABS_CONFIG = [
    {
        value: "tab-tasks",
        label: i18n.t("liveView.tasksInstances.tasksTitle")
    },
    {
        value: "tab-instances",
        label: i18n.t("liveView.tasksInstances.instancesTitle")
    }
];
